import { SharingDraft } from '@/types';
import { postRequest } from './methods/postRequest';
import { requestToJSON } from './methods/requestToJSON';

export const saveSharingDraft = (draft: Partial<SharingDraft>) =>
  requestToJSON<SharingDraft>(postRequest('/api/drafts/', draft));
